import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';

export default function Header({ logoSrc, variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [token, setUserToken] = useState(null);

  const location = useLocation(); // Get current route

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);

    const storedToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (storedToken) setUserToken(storedToken);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
  alert("Logged out successfully");
  localStorage.clear();
  sessionStorage.clear();  // 👈 add this
  setUserToken(null);
  setMobileToggle(false);
  window.location.href = "/signIn";
};

  const isActive = (path) => location.pathname === path; // Check if link is active

  return (
    <>
      <header
        className={`cs_site_header cs_style1 cs_sticky_header ${mobileToggle ? 'cs_mobile_toggle_active' : ''
          } ${variant} ${isSticky ? 'cs_active_sticky' : ''}`}
      >
        <div className="cs_main_header">
          <div className="container">
            <div className="cs_main_header_in flex items-center justify-between">
              <div className="cs_main_header_left flex items-center gap-5">
                <Link className="cs_site_branding" to="/">
                  <img src={logoSrc} alt="Logo" />
                </Link>
                <nav className="cs_nav">
                  <ul className={mobileToggle ? 'cs_nav_list cs_active' : 'cs_nav_list'}
                  onClick={() => setMobileToggle(false)} >
                    <li>
                      <Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link>
                    </li>
                    <li>
                      <Link to="/about" className={isActive('/about') ? 'active' : ''}>About Us</Link>
                    </li>
                    <li>
                      <Link to="/doctors" className={isActive('/doctors') ? 'active' : ''}>Doctors</Link>
                    </li>
                     <li>
                      <Link to="/blog" className={isActive('/blog') ? 'active' : ''}>Blog</Link>
                    </li> 
                    <li>
                      <Link to="/faqs" className={isActive('/faqs') ? 'active' : ''}>FAQS</Link>
                    </li> 
                    <li>
                      <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact Us</Link>
                    </li>

                    {token ? (
                      <>
                        <li style={{ marginBottom:"4px" }}>
                          <Link to="/patientprofile" className={isActive('/patientprofile') ? 'active' : ''}>Patient Profile</Link>
                        </li>
                        <li style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <button
                            onClick={handleLogout}
                            style={{
                              border: "none",
                              outline: "none",
                              background: "none",
                              color: "rgba(44, 75, 98, 1)",
                              cursor: "pointer",
                              marginLeft: "10px",
                              marginTop:"4px"
                            }}

                            onMouseOver={(e) => (e.target.style.color = "#51a3e2")}
                            onMouseOut={(e) => (e.target.style.color = "#345269")}
                          >
                            Logout
                          </button>
                          <a
                            href="https://wa.me/919876543210"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-green-500 hover:text-green-600 transition"
                          >
                           
                          </a>
                        </li>
                      </>
                    ) : (
                   <>
                    <li>
                      <Link to="/signIn" className={isActive('/signIn') ? 'active' : ''}>
                        Sign In
                      </Link>
                    </li>
                    <li>
                      <Link to="/signup" className={isActive('/signup') ? 'active' : ''} >
                        Sign Up
                      </Link>
                    </li>
                  </> 
                    )}
                  </ul>

                  <span
                    className={mobileToggle ? 'cs_menu_toggle cs_teggle_active' : 'cs_menu_toggle'}
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
